import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import { Flex, Typography } from '@iheartjane/reefer';
import type { TimeZone } from '@iheartjane/types';

/* eslint-disable-next-line no-restricted-imports */
import type { Store, StoreSpecial } from '@jane/shared/models';

import { GovernmentAssistanceIdentification } from '../../../../identification/governmentAssistanceIdentification';
import { IDIdentification } from '../../../../identification/idIdentification';
import { MedicalIdNumberIdentification } from '../../../../identification/medicalIdNumberIdentification';
import { MMJIdentification } from '../../../../identification/mmjIdentification';
import { PediatricIdentification } from '../../../../identification/pediatricIdentification';
import { SeniorIdentification } from '../../../../identification/seniorIdentification';
import { StudentIdentification } from '../../../../identification/studentIdentification';
import { VeteranIdentification } from '../../../../identification/veteranIdentification';

const renderUploader = ({
  groupType,
  timezone,
  requiredAge,
  store,
  verificationType,
}: {
  groupType: string;
  requiredAge?: number | null;
  store: Store;
  timezone: TimeZone;
  verificationType?: string | null;
}) => {
  const { medical, state } = store;

  if (groupType === 'medical') {
    if (state === 'Ohio' && medical) return null;

    return verificationType === 'number' ? (
      <MedicalIdNumberIdentification />
    ) : (
      <MMJIdentification />
    );
  }

  return groupType === 'student' ? (
    <StudentIdentification />
  ) : groupType === 'senior' ? (
    <SeniorIdentification requiredAge={requiredAge || 1} timezone={timezone} />
  ) : groupType === 'veteran' ? (
    <VeteranIdentification />
  ) : groupType === 'pediatric' ? (
    <PediatricIdentification
      requiredAge={requiredAge || 1}
      timezone={timezone}
    />
  ) : groupType === 'ssi' ? (
    <IDIdentification />
  ) : groupType === 'snap' ? (
    <IDIdentification />
  ) : groupType === 'medicare' ? (
    <IDIdentification />
  ) : groupType === 'pace' ? (
    <GovernmentAssistanceIdentification />
  ) : groupType === 'pacenet' ? (
    <GovernmentAssistanceIdentification />
  ) : groupType === 'chip' ? (
    <GovernmentAssistanceIdentification />
  ) : groupType === 'wic' ? (
    <GovernmentAssistanceIdentification />
  ) : groupType === 'PA Gov' ? (
    <GovernmentAssistanceIdentification />
  ) : groupType === 'medicaid' ? (
    <IDIdentification />
  ) : groupType === 'locals' ? (
    <IDIdentification />
  ) : groupType === 'industry' ? (
    <IDIdentification />
  ) : null;
};

export const GroupDiscountDetails = ({
  special,
  timezone,
  store,
}: {
  special?: StoreSpecial;
  store?: Store;
  timezone: TimeZone;
}) => {
  const medIdEnabled = useFlag(FLAGS.c3QualifiedGroupMedId);

  if (!special || special.special_type !== 'qualified_group') return null;
  const groupRules = special.rules?.base;
  if (!groupRules?.type) return null;

  return (
    <Flex
      flexDirection="column"
      width="100%"
      pb={24}
      style={{ containerType: 'inline-size' }}
    >
      {special.terms && (
        <Typography color="text-light" mb={24}>
          {special.terms}
        </Typography>
      )}

      {renderUploader({
        groupType: groupRules.type,
        timezone,
        requiredAge: groupRules.required_age ?? null,
        verificationType: medIdEnabled
          ? groupRules.verification_type || 'photo'
          : 'photo',
        store: store as Store,
      })}
    </Flex>
  );
};
